import { AbstractControl, ValidationErrors } from "@angular/forms";
import { DateTimeUtils } from "../shared/datetimeutils";
import * as moment from "moment";

export class WorkScheduleValidator {

  public static timeRangeValidator(formGroup: AbstractControl): ValidationErrors | null {

    let fromControl = formGroup.get('from');
    let toControl = formGroup.get('to');
    let activeDate = formGroup.get('activeDate');

    let from = DateTimeUtils.convertStringToDateFrom(activeDate.value, fromControl.value);
    let to = DateTimeUtils.convertStringToDateTo(activeDate.value, toControl.value);

    let diff = moment(to).diff(moment(from), 'minutes');

    if (diff <= 0) {
      return { invalidRange: true };
    }

    if (diff >= 24 * 60) {
      return { moreThan24hrs: true };
    }

    return null;
  }
}
